export * from 'server/models/TopicCardUserAssignment';


// WEBPACK FOOTER //
// ./data/models/TopicCardUserAssignment.ts